/* eslint-disable react/prop-types */
import React from 'react';

import { Dialog, DialogTitle, IconButton, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import { makeStyles } from 'tss-react/mui';
import StripeGetPremiumForUserLoggedIn from './StripeGetPremiumForUserLoggedIn';
import {
  isPaymentModalOpenSelector,
  setIsPaymentModalOpenSelector,
  usePaymentModalOpenStore,
} from 'stores/paymentModalStore';

const useStyles = makeStyles()((theme) => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

// COMPONENT
function StripeGetPremiumModal() {
  const isPaymentModalOpen = usePaymentModalOpenStore(isPaymentModalOpenSelector);
  const setIsPaymentModalOpen = usePaymentModalOpenStore(setIsPaymentModalOpenSelector);

  const { classes } = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const onClose = () => {
    setIsPaymentModalOpen(false);
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      maxWidth="md"
      open={isPaymentModalOpen}
      scroll="body"
      onBackdropClick={onClose}
    >
      <DialogTitle>
        <IconButton aria-label="Close" className={classes.closeButton} onClick={onClose} size="large">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <StripeGetPremiumForUserLoggedIn noBox />
    </Dialog>
  );
}

export default StripeGetPremiumModal;
